import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 *
 * @param {Object} prop
 */

const useFetchOrganizacion = (grupoBalance) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    const params = { idioma: '01' }

    if (grupoBalance !== '' && grupoBalance !== null) {
      params.gb = grupoBalance
    }
    setLoading(true)
    axios
      .get('/organizacionCompras/', { params })
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [grupoBalance])

  useEffect(() => {
    if (!loading) fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grupoBalance])

  return { response, error, loading }
}

export default useFetchOrganizacion
